<template>
<div id="financial">
    <!-- success alert -->
    <v-dialog
      v-model="alert"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{'emp._Saved_info_'|translate}}</v-card-title>

        <v-card-text>
          {{'emp._Saved_info_'|translate}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="alert = false"
          >
           {{'general._ok_'|translate}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Success Alert end -->

    <!-- current job dialog -->
   <v-dialog v-show="showCurrentJobInfo" v-model="showCurrentJobInfo" persistent max-width="700">
      <v-layout row>
    <v-flex xs12>
      <v-card>
       <v-toolbar color="primary" dark>
          <v-toolbar-side-icon @click="showCurrentJobInfo = false"><v-icon>close</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>{{'emp._Add_job_info_'|translate}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      <current-job></current-job>
      <v-card-actions>
      </v-card-actions>
      </v-card>
    </v-flex>
      </v-layout>
   </v-dialog>

   <!-- jobSearch dialog -->
   <v-dialog v-show="showJobSearchInfo" v-model="showJobSearchInfo" persistent max-width="700">
      <v-layout row>
    <v-flex xs12>
      <v-card>
       <v-toolbar color="primary" dark>
          <v-toolbar-side-icon v-on:click="showJobSearchInfo = false"><v-icon >close</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>{{'emp._Add_search_info_'|translate}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      <job-search></job-search>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
      </v-card>
    </v-flex>
      </v-layout>
   </v-dialog>


     <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
     <v-toolbar>
     <v-toolbar-title>
       <v-list-tile>
        <v-list-tile-avatar size="50">
               <img v-on:click="photoDialog" style="cursor:pointer" v-bind:src="imageUrl"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{form.firstName}} {{form.lastName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{'members._access_code_'|translate}} : {{ this.form.accessCode }}</v-list-tile-sub-title>
              </v-list-tile-content>
       </v-list-tile>
    </v-toolbar-title>
     </v-toolbar>
      <v-card>
<form @submit.prevent="validateFinancialInfo">
      <v-card>
        <v-card-title>
      <br>
        <!-- travailler vous card -->
            <v-flex xs12 sm6>
              <v-card>
                <v-card-title>
                  <v-flex>
                     <v-flex xs12 sm6>
           <label id="isWorking" for="isWorking">{{'emp._work_now_'|translate}} </label>
                <v-radio-group
                name="Travaillez vous?"
                    :error-messages="errors.collect('Travaillez vous?')"
                    v-validate="'required'"
                v-model="form.isWorking"
                row>

                  <v-radio :label="$t('general._yes_')" v-on:change="showCurrentJobInfo=true" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" :value="false"></v-radio>
              </v-radio-group>
                     </v-flex>
                     <v-flex xs12 sm6 v-show="currentJobInfoState">
                       <div class="text-xs-center">
                    <v-chip v-model="stateSet" close>
                      <v-btn @click="showCurrentJobInfo = true" icon>
                        <v-icon>work</v-icon>
                      </v-btn>
                     {{'emp._work_info_'|translate}}
                    </v-chip>
                  </div>
                     </v-flex>
                  </v-flex>
                   </v-card-title>
            </v-card>
            </v-flex>
                     

          <!-- disponible pour travailler -->
                        <v-flex xs12 sm6>
              <v-card>
                <v-card-title>
                  <v-flex>
                     <v-flex xs12 sm6>
           <label>Êtes-vous disponible pour travailler?</label>
                <v-radio-group
                    name="Disponible pour travailler"
                    :error-messages="errors.collect('Disponible pour travailler')"
                    v-validate="'required'"
                v-model="form.isWorkReady"
                row>
                 <v-radio :label="$t('general._yes_')"  v-on:change="showJobSearchInfo = true" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" :value="false"></v-radio>
              </v-radio-group>
                     </v-flex>
                     <v-flex xs12 v-show="!searchJobInfoState">
                <v-text-field
                label="Pourquoi vous n'êtes pas disponible?"
                type="text" v-model="form.notAvailableReason">
              </v-text-field>
                </v-flex>
                     <v-flex xs12 sm6 v-show="searchJobInfoState">
                       <div class="text-xs-center">
                    <v-chip v-model="searchStateSet" close>
                      <v-btn @click="showJobSearchInfo = true" icon>
                        <v-icon>work</v-icon>
                      </v-btn>
                      Disponibilités de travaille
                    </v-chip>
                  </div>
                     </v-flex>
                  </v-flex>
                   </v-card-title>
            </v-card>
            </v-flex>
                  <!-- <label id="isJobSearching" for="isJobSearching">Êtes-vous en recherche d'emploi?</label>
                <form class="form-inline">
                <v-radio v-model="form.isJobSearching" v-on:change="showWork = true" value="Oui">Oui</v-radio>
                <v-radio v-model="form.isJobSearching" v-on:change="showWork = false" value="Non">Non</v-radio>
                </form> -->

                <!-- old card -->

                <!-- <v-flex xs12>
                   <v-card>
                <v-card-title>
                  <v-flex>
                <v-flex xs12 sm6>
                <label id="isWorkReady" for="isWorkReady">Êtes-vous disponible pour travailler? {{form.isWorkReady}}</label>
                <v-radio-group
                name="Prêt pour travailler"
                    :error-messages="errors.collect('Prêt pour travailler')"
                    v-validate="'required'"
                v-model="form.isWorkReady"
                row>
                <v-radio label="Oui" v-on:change="showJobSearchInfo=true, searchStateSet= true" value="Oui">Oui</v-radio>
                <v-radio label="Non" v-on:change="showJobSearchInfo=false, searchStateSet= false" value="Non">Non</v-radio>
                </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6 v-if="!searchStateSet">
                <v-text-field
                label="Pourquoi vous n'êtes pas disponible?"
                type="text" name="notAvailableReason" id="notAvailableReason" v-model="form.notAvailableReason">
              </v-text-field>
                </v-flex>
                </v-flex>
              </v-card-title>
              
            </v-card>
            </v-flex> -->



                <v-flex xs12 sm6>
                  <v-card>
                  <v-card-title>
                    <v-flex xs12>
                  <label id="isEducationReady" for="isEducationReady">Êtes vous disponibles à recevoir une éducation financière de EJCEV-BIMA?</label>
                <v-radio-group
                v-model="form.isEducationReady"
                name="Prêt pour une éducation"
                :error-messages="errors.collect('Prêt pour une éducation')"
                v-validate="'required'"
                row>
                <v-radio :label="$t('general._yes_')"  v-on:change="educationStateSet=true" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" :value="false"></v-radio>
                </v-radio-group>
                </v-flex>
               <v-flex xs12 v-if="showEducation">
            <v-text-field
            label="Fréquence de disponibilité?"
            type="number" min="0"
            append-icon="watch"
            v-model.number="form.education.amount"
            >
            
             <v-select
             label= "fréquence"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence"
                :error-messages="errors.collect('fréquence')"
                v-validate="'required'"
              v-model="form.education.frequency"
                :items="[$t('emp._Byday_'), $t('emp._Byweek_'), $t('emp._Bymonth_'),$t('emp._Byyears_')]">
              
               </v-select>
            </v-text-field>
               </v-flex>
                  </v-card-title>
                  </v-card>
               </v-flex>
          <br>
                  <v-flex xs12 sm6>
                  <v-card>
                  <v-card-title>
                    <v-flex xs12 sm6>
               <label>{{'emp._house_'|translate}}</label>
                <v-radio-group
                name="possède un maison"
                :error-messages="errors.collect('possède un maison')"
                v-validate="'required'"
                v-model="form.isHouseOwner"
                row>
                <v-radio :label="$t('general._yes_')"  v-on:change="showHouse=true, form.isRenting=false" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" v-on:change="showHouse=false, form.isRenting=true" :value="false"></v-radio>

                </v-radio-group>
                 </v-flex>
                 <v-flex xs12 sm6>
            <label id="isRenting" for="isRenting">{{'emp._tenant_'|translate}}</label>
                <v-radio-group
                name="locataire"
                    :error-messages="errors.collect('locataire')"
                    v-validate="'required'"
                v-model="form.isRenting"
                row>
                <v-radio :label="$t('general._yes_')"  v-on:change="showHouse=Non" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" v-on:change="showHouse=Oui" :value="false"></v-radio>

                </v-radio-group>
                    </v-flex>
                   
                <v-flex xs12 v-if="showHouse">
              <v-text-field
              :label="$t('emp._since_when_')"
            type="number" min="0"
            append-icon="cash"
            v-model.number="form.houseOwnerSince.nombre"
            >
            
             <v-select
             :label="$t('emp._frequency_')"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence"
                :error-messages="errors.collect('fréquence')"
                v-validate="'required'"
             v-model="form.houseOwnerSince.frequency"
               :items="[$t('emp._Byday_'), $t('emp._Byweek_'), $t('emp._Bymonth_'),$t('emp._Byyears_')]">
               
               </v-select>
            </v-text-field>
           <!-- <b-input-group prepend="Quel est le coût de votre hypotèque(mois)? $">
          <b-form-input type="number" min="0" v-model.number="form.mortgageAmount"></b-form-input>
        </b-input-group> -->
                </v-flex>
                  </v-card-title>
                  </v-card>
                  </v-flex>
            
                <!-- <div class="md-layout-item" v-show="showRent">
                <b-input-group prepend="Quel est le coût de votre loyer par mois? $">
                  <b-form-input type="number" min="0" v-model.number="form.rentAmount"></b-form-input>
                </b-input-group>
                </div> -->
        </v-card-title>
      </v-card>
      <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn type="submit" color="primary">{{'general._save_'|translate}}</v-btn>
        </v-card-actions>
        </form>
      </v-card>
    </v-layout>
     </v-container>
    
</div>
        </template>
<script>
/* eslint-disable */
import fr from "vee-validate/dist/locale/fr";
import firebase, { functions } from "firebase";
import VeeValidate, { Validator } from "vee-validate";
import { db } from "@/api/firebaseInit";
import { auth } from "@/api/firebaseInit";
import CurrentJob from "./CurrentJob";
import JobSearch from "./JobSearch";
Validator.localize("fr", fr);
export default {
  name: "financial",
  components: {
    CurrentJob,
    JobSearch
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      headers: [
        { text: "Prénom et Nom", value: "lastName" },
        { text: "Code d'accès", value: "accessCode" },
        { text: "Telephone", value: "phone" }
      ],
      alert: false,
      showCurrentJobInfo: false,
      showJobSearchInfo: false,
      stateSet: true,
      searchStateSet: true,
      educationStateSet: false,
      availableStateSet: true,
      member: null,
      member_id: "",
      showHouse: false
      // member_id: '',
      // form: {
      //   phone: '',
      //   accessCode: '',
      //   imageUrl: '/static/avatar/avatar.png',
      //   lastName: '',
      //   firstName: '',
      //   timeOnCurrentJob: {
      //     amount: 6,
      //     frequency: "mois"
      //   },
      //   jobPosition: null,
      //   numberOfJobs: 1,
      //   jobRepartition: "Temps plein",
      //   jobWeeklyHours: 40,
      //   jobTravelTime: {
      //     hours: 0,
      //     minutes: 30
      //   },
      //   jobTravelDistance: "plus de 30 km",
      //   jobTravelMode: "Vélo",
      //   jobTravelCost: 0,
      //   jobMonthlyPay: 10,
      //   jobSkills: null,
      //   jobSearch: {
      //     amount: 1,
      //     frequency: "mois"
      //   },
      //   jobType: null,
      //   availableTime: 0,
      //   jobDisponibility: {
      //     amount: 1,
      //     frequency: "Par mois"
      // },
      //   isWorking: "Non",
      //   isWorkReady: "Non",
      //   // isJobSearching: "Non",
      //   isEducationReady: "Non",
      //   notAvailableReason: 'Non disponible',
      //   education: {
      //     nombre: 0,
      //     frequency: "Par jour"
      //   },
      //   houseOwnerSince: {
      //     nombre: 0,
      //     frequency: "Ans"
      //   },
      //   isHouseOwner: "Non",
      //   // mortgageAmount: 0,
      //   isRenting: "Non",
      //   // rentAmount: 0
      // },
    };
  },
  created() {
    this.$validator.localize("fr", this.dictionary);
    //  this.member_id = this.$store.getters.getCurrentMemberId;
  },
  computed: {
    form() {
      let form = this.$store.getters.getCurrentMember;
      this.member_id = form.id;
      return form;
    },
    imageUrl() {
      return this.$store.getters.memberPhoto;
    },
      currentJobInfoState: {
        get () {
      let current = false;
      if (this.form.isWorking === true) {
           current = true
           }
      return current;
        }
      },
         showEducation () {
      let education = false;
      if (this.form.isEducationReady === true) {
           education = true
           }
      return education;
      },
         searchJobInfoState () {
      let search = false;
      if (this.form.isWorkReady === true) {
           search = true
           }
      return search;
      },
  },
  watch: {
    form(val) {
      return this.$store.commit("currentMember", val);
    },
    stateSet(val){
      if(!val) {
        this.form.isWorking = false;
      }
    },
    searchStateSet(val){
      if(!val) {
        this.form.isWorkReady = false;
      }
    },
  // educationStateSet(val){
  //     if(!val) {
  //       this.form.isEducationReady = "Non";
  //     } else {
  //       this.form.isEducationReady = "Oui";
  //     }
  //   },
    // availableStateSet(val){
    //   if(!val) {
    //     this.form.isWorkReady = "Non";
    //   }
    // }
  },
  methods: {
    fetchData() {
      db.collection("Census")
        .doc(this.member_id)
        .get()
        .then(doc => {
          (this.form.accessCode = doc.data().accessCode),
            (this.form.phone = doc.data().phone),
            (this.form.imageUrl = doc.data().imageUrl),
            (this.form.firstName = doc.data().firstName),
            (this.form.lastName = doc.data().lastName),
            (this.form.isWorking = doc.data().isWorking),
            (this.form.isWorkReady = doc.data().isWorkReady),
            (this.form.notAvailableReason = doc.data().notAvailableReason),
            (this.form.isEducationReady = doc.data().isEducationReady),
            (this.form.isHouseOwner = doc.data().isHouseOwner),
            (this.form.isRenting = doc.data().isRenting),
            (this.form.jobSkills = doc.data().jobSkills),
            (this.form.jobSearch = doc.data().jobSearch),
            (this.form.jobType = doc.data().jobType),
            (this.form.availableTime = doc.data().availableTime),
            (this.form.jobDisponibility = doc.data().jobDisponibility),
            (this.form.timeOnCurrentJob = doc.data().timeOnCurrentJob),
            (this.form.jobPosition = doc.data().jobPosition),
            (this.form.numberOfJobs = doc.data().numberOfJobs),
            (this.form.jobRepartition = doc.data().jobRepartition),
            (this.form.jobWeeklyHours = doc.data().jobWeeklyHours),
            (this.form.jobTravelDistance = doc.data().jobTravelDistance),
            (this.form.jobTravelMode = doc.data().jobTravelMode),
            (this.form.jobTravelCost = doc.data().jobTravelCost),
            (this.form.jobTravelTime = doc.data().jobTravelTime),
            (this.form.jobMonthlyPay = doc.data().jobMonthlyPay);
          if (!this.form.isWorkReady) {
            this.form.isWorkReady = false;
          }
          if (!this.form.isWorking) {
            this.form.isWorking = false;
          }
          if (!this.form.houseOwnerSince) {
            this.form.houseOwnerSince = {
              amount: 0,
              frequency: "Par semaine"
            };
          }
          if (!this.form.education) {
            this.form.education = {
              amount: 0,
              frequency: "Par semaine"
            };
          }
          if (!this.form.notAvailableReason) {
            this.form.notAvailableReason = "pas disponible";
          }
          this.$store.commit("currentMember", form);
        });
    },
    validateFinancialInfo() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.saveFinanceInfo();
        } else {
          return;
        }
      });
    },
    saveFinanceInfo() {
      db.collection("Census")
        .doc(this.member_id)
        .update({
          isWorking: this.form.isWorking,
          // isJobSearching: this.form.isJobSearching,
          isWorkReady: this.form.isWorkReady,
          notAvailableReason: this.form.notAvailableReason,
          isEducationReady: this.form.isEducationReady,
          isHouseOwner: this.form.isHouseOwner,
          education: this.form.education,
          houseOwnerSince: this.form.houseOwnerSince,
          isRenting: this.form.isRenting
        })
        .then(() => {
          this.alert = true;
          this.$router.push('/widgets/todaylist')
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
    photoDialog() {
      this.$router.push("/appphoto");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/form/steppers/Financial.vue